<template>
  <div class="page-about-drug">
    <!-- Begin head block -->
    <section class="head-block">
      <div class="container">
        <div class="row">
          <div class="col-x-lg-6 col-lg-6 col-md-6 col-xs-12">
            <div class="head-block__detail">
              <h1
                class="head-block__detail-title"
                v-html="$t('aboutDrug.title')"
              ></h1>
              <p
                class="head-block__detail-text"
                v-html="$t('aboutDrug.text')"
              ></p>
            </div>
          </div>
          <div class="col-x-lg-6 col-lg-6 col-md-6 col-xs-12">
            <div class="head-block__image">
              <img src="~@/assets/img/about-drug/image-1.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
    <!-- Begin list block -->
    <section class="list-block">
      <div class="container">
        <div
          class="list-block__title"
          v-html="$t('aboutDrug.list.title')"
        ></div>
        <div class="list-block__row">
          <div class="list-block__col">
            <div class="list-block__item list-block__item--1">
              <span v-html="$t('aboutDrug.list.item_1')"></span>
            </div>
          </div>
          <div class="list-block__col">
            <div class="list-block__item list-block__item--2">
              <span v-html="$t('aboutDrug.list.item_2')"></span>
            </div>
          </div>
          <div class="list-block__col">
            <div class="list-block__item list-block__item--3">
              <span v-html="$t('aboutDrug.list.item_3')"></span>
            </div>
          </div>
          <div class="list-block__col">
            <div class="list-block__item list-block__item--4">
              <span v-html="$t('aboutDrug.list.item_4')"></span>
            </div>
          </div>
        </div>
        <div class="list-block__footer">
          <div class="row">
            <div class="col-x-lg-6 col-lg-6 col-md-5 col-xs-12">
              <div class="list-block__btn-wrap">
                <router-link
                  @click.native="drugMainBtn()"
                  :to="$t('aboutDrug.button.link')"
                  class="list-block__btn"
                  >{{ $t("aboutDrug.button.title") }}</router-link
                >
              </div>
            </div>
            <div class="col-x-lg-6 col-lg-6 col-md-7 col-xs-12">
              <div class="list-block__info">
                <h5
                  class="list-block__info-title"
                  v-html="$t('aboutDrug.info.title')"
                ></h5>
                <p
                  class="list-block__info-text"
                  v-html="$t('aboutDrug.info.text')"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
    <!-- Begin bibliography -->
    <section class="bibliography">
      <div class="container">
        <div class="bibliography__info">
          <p v-html="$t('bibliography.info_1')"></p>
        </div>
        <div class="bibliography__list">
          <h3
            class="bibliography__list-title"
            v-html="$t('bibliography.bibliographyTitle')"
          ></h3>
          <div
            class="bibliography__list-item"
            v-for="(item, key) in $t('aboutDrug.bibliography.list')"
            :key="key"
          >
            <div class="bibliography__list-number">{{ key + 1 }}.</div>
            <div class="bibliography__list-text" v-html="item"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
  </div>
</template>

<script>
export default {
  name: "AboutDrugView",
  metaInfo() {
    if (this.$i18n.locale === "ua") {
      return {
        title: "Оксиметазолін у складі Називін® Сенситив",
        meta: [
          {
            name: "description",
            content:
              "Називін® Сенситив – це єдиний 💪 спрей оксиметазоліну гідрохлориду без додавання консерванта бензалконію хлориду 🧪"
          },
          {
            property: "og:description",
            content: "Оксиметазолін у складі Називін® Сенситив"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (this.$i18n.locale === "ru") {
      return {
        title: "Оксиметазолин в составе Називин® Сенситив",
        meta: [
          {
            name: "description",
            content:
              "Називин® Сенситив - это единственный 💪 спрей оксиметазолину гидрохлорида без добавления консерванта бензалкония хлорида 🧪"
          },
          {
            property: "og:description",
            content: "Оксиметазолин в составе Називин® Сенситив"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
  },
  methods: {
    drugMainBtn() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "drug_main_btn" });
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/views/_about-drug";
</style>
